<template>
<div id="error-page" :style="{height: bodyHeight}">
    <h2>没有网络吼~</h2>
    <p>“不小心传回到80年代，网络信号是什么鬼？”</p>
    <span @click="refresh">刷新一下</span>
</div>
</template>
<script>

    export default {
        name: 'Error',
        data () {
            return {
                bodyHeight: ''
            }
        },
        // 生命周期钩子
        mounted () {
            this.bodyHeight = window.screen.height + 'px';
            document.title = '无网络';
        },
        methods: {
            refresh() {
                window.location.reload();
            }
        }
    }
</script>
<style scoped>
#error-page {

    &:before {
         margin: 111px auto 41px auto;
         display: block;
         content: '';
         width: 246px;
         height: 288px;
         background: url("../assets/no-network.png") 50% 50% no-repeat;
         background-size: 246px 288px;
    }

     h2 {
         font-family:"PingFangSC-Medium";
         font-size:34px;
         font-weight: 800;
         text-align: center;
         color:#323232;
         width: 100%;
     }

     p {
         font-family:"PingFangSC-Regular";
         font-size:26px;
         color:rgba(3,3,3,0.50);
         text-align:center;
         display: block;
         width: 100%;
         margin-top: 10px;
     }
     span {
         display: block;
         margin: 0 auto;
         background:#ffb500;
         box-shadow:0 0 8px 4px rgba(255,170,0,0.21);
         border-radius:6px;
         width:216px;
         height:66px;
         font-family:"PingFangSC-Semibold";
         font-size:34px;
         line-height: 66px;
         color:#ffffff;
         text-align:center;
         font-weight: 500;
         margin-top: 46px;
     }
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue